import { render, staticRenderFns } from "./PatChk.vue?vue&type=template&id=b35dfc46&scoped=true"
import script from "./PatChk.vue?vue&type=script&lang=js"
export * from "./PatChk.vue?vue&type=script&lang=js"
import style0 from "./PatChk.vue?vue&type=style&index=0&id=b35dfc46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35dfc46",
  null
  
)

export default component.exports